<template>
  <div id="app">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-inner">
        <router-link to="/" class="logo">
          <img src="/logo.png" alt="凡志红五金" class="logo-img" />
          <span>
            凡志红五金
            <span class="logo-sub">FANZHIHONG HARDWARE</span>
          </span>
        </router-link>
        <nav class="nav">
          <router-link to="/" exact-active-class="active" class="nav-link">首页</router-link>
          <router-link to="/products" active-class="active" class="nav-link">产品中心</router-link>
          <router-link to="/contact" active-class="active" class="nav-link">联系我们</router-link>
        </nav>
      </div>
    </header>

    <!-- 主要内容 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 底部信息 -->
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-col">
          <h3>昆山凡志红五金有限公司</h3>
          <p class="footer-en">KUNSHAN FANZHIHONG HARDWARE CO., LTD.</p>
          <p>专业手钣样品制作 · 快速响应 · 精准交付 · 全程把控。深耕手钣加工领域二十余年，主营不锈钢、铜材、铝材等多种材质的精密加工。</p>
        </div>
        <div class="footer-col">
          <h4>快速导航</h4>
          <div class="footer-nav">
            <router-link to="/">首页</router-link>
            <router-link to="/products">产品中心</router-link>
            <router-link to="/contact">联系我们</router-link>
          </div>
        </div>
        <div class="footer-col">
          <h4>联系我们</h4>
          <p>📞 电话：<span class="footer-highlight">13390873271</span></p>
          <p>📍 地址：江苏省苏州市昆山市玉山镇富士康路758-5号</p>
          <p>🌐 网址：www.ksfzhwj.top</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© 2026 昆山凡志红五金有限公司 版权所有 · 统一社会信用代码 91320583MAK34ABY3F</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
